const normalizeTitle = title => String(title || '')
  .replace(/<[^>]*>/g, '')
  .trim();

const isGiftOnlyGoods = goods => {
  if (!goods) return false;
  if (Number(goods.is_gift) === 1) return true;
  return /^[\(（]\s*赠品\s*[\)）]/.test(normalizeTitle(goods.title));
};

module.exports = {
  isGiftOnlyGoods
};
